































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { GEnum } from '@/constants/enum.defination';
import { Component } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GClassManagementCompetencyRanking from './GClassManagementCompetencyRanking.vue';
import GClassManagementCompetencyAllRanking from '@/views/GClassManagement/GClassManagementCompetencyAllRanking.vue';
import { SchoolGroup } from '@/models/school-group/school-group';
import { SchoolGroupCompetencyRanking } from '@/models/school-group/school-group-competency-ranking';
import { SchoolClassTrendResult } from '@/models/school-class/school-class-trend-results';
import { Tag } from '@/models/tag';
import GClassManagementGroupSettingModal from './GClassManagementGroupSettingModal.vue';
import GClassManagementGroupTable from './GClassManagementGroupTable.vue';
import GClassManagementClassTrend from './GClassManagementClassTrend.vue';
import GClassManagementGroupingProposalConfirm from './GClassManagementGroupingProposalConfirm.vue';
import GClassManagementPmAnalysis from './GClassManagementPmAnalysis.vue';
import GClassManagementTrendAnalysisGrowthMindsetMap from './GClassManagementTrendAnalysisGrowthMindsetMap.vue';
import GClassManagementTrendAnalysisPsychologicalSafety from './GClassManagementTrendAnalysisPsychologicalSafety.vue';
import GClassManagementTrendAnalysisHumanitiesOrSciences from './GClassManagementTrendAnalysisHumanitiesOrSciences.vue';
import GTopicFormForTrendAnalysis from '@/views/GClassManagement/GTopicFormForTrendAnalysis.vue';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import { CompetencySetting } from '@/models/competency/competency-setting';
import { SchoolGroupPMAnalysis } from '@/models/school-group/school-group-pm-analysis';
import GClassManagementGroupingProposal from './GClassManagementGroupingProposal.vue';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import { studentModule } from '@/store/modules/entities/student.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { SchoolGroupSearch } from '@/models/school-group/school-group-search';
import { CompetencyRankingParams } from '@/models/competency/competency-ranking-params';
import GStudentFilter from '@/components/GStudentFilter.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import { StudentSearch } from '@/models/student/student-search';
import { globalModule } from '@/store/modules/global.module';
import { SchoolGroupTrendAnalysis } from '@/models/school-group/school-group-trend-analysis';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave']);
@Component({
  name: 'GClassManagement',
  components: {
    GCustomBreadCrumb,
    GTitleBar,
    GStudentFilter,
    GClassManagementGroupingProposal,
    GTemplateTopicForm,
    GTopicFormForTrendAnalysis,
    GClassManagementGroupingProposalConfirm,
    GClassManagementClassTrend,
    GClassManagementGroupTable,
    GClassManagementGroupSettingModal,
    GClassManagementCompetencyRanking,
    GClassManagementCompetencyAllRanking,
    GClassManagementPmAnalysis,
    GClassManagementTrendAnalysisGrowthMindsetMap,
    GClassManagementTrendAnalysisPsychologicalSafety,
    GClassManagementTrendAnalysisHumanitiesOrSciences,
  },
  computed: {},
  methods: {},
})
export default class GClassManagement extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  studentsGroupTableColumns: any[] = [];
  isShowSchoolClassTrend: boolean = true;
  // isShowGroupingProposal: boolean = true;
  isStudentFilterAwait: boolean = false;
  isSearchResultShow: boolean = false;

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isGroupSettingsDataSubmitted) {
      //グループ提案時の他画面遷移は確認ダイアログを表示する
      this.openConfirm(
        //OK押下時は画面遷移を許容する
        () => {
          next();
        },
        () => {}
      );
    } else {
      next();
    }
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name !== 'competency-ranking-details' && from.name !== 'group-edit') {
        //   //生徒カルテ画面から戻ってきた時のみ、キャッシュデータを保持する
        vm.clearStudentFilters();
      }
      vm.isStudentFilterAwait = true;
    });
  }

  async mounted() {
    const schoolGroupSettingInfoOptions = {
      isShowGroupsettingModal: false,
      isGroupSettingsDataSubmitted: false,
    };
    if (this.isOldSchoolYear) {
      this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home' }, { title: this.$t('SCHOOL_CLASS_MANAGEMENT').toString() }]; //リンクなし
    } else {
      this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }, { title: this.$t('SCHOOL_CLASS_MANAGEMENT').toString() }];
    }

    if (!this.isOldSchoolYear) {
      //成長目的を取得
      masterModule.fetchGrowingPurposes();
      groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
      //全クラスのクラス傾向を取得
      await schoolClassModule.fetchSchoolClassTrendResults();
      const schoolClassTrendResult: SchoolClassTrendResult = schoolClassModule.schoolClassTrendResultBySchoolClassID(this.schoolClassID);
      schoolClassModule.setSchoolClassTrendResult(schoolClassTrendResult);
    }
  }

  handleFetchSchoolGroupPMAnalysis(growingPurposeID: number) {
    statisticsModule.fetchSchoolGroupPMAnalysis({
      targetType: this.targetType,
      targetID: this.targetID,
      selectedCommaTagIDs: this.selectedCommaTagIDs,
      growingPurpose: growingPurposeID,
    });
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get isOneSchoolClassSearch(): boolean {
    return this.schoolClassID !== 0;
  }

  get schoolClassTrendResult(): SchoolClassTrendResult {
    return schoolClassModule.schoolClassTrendResult;
  }

  get schoolGroupPMAnalysis(): SchoolGroupPMAnalysis {
    return statisticsModule.schoolGroupPMAnalysisByGrowingPurposeID;
  }

  get schoolGroupTrendAnalysis(): SchoolGroupTrendAnalysis {
    return statisticsModule.schoolGroupTrendAnalysis;
  }

  get isSchoolClassSearch(): boolean {
    //クラス検索(全クラス除く)、かつ、年組検索対象で検索
    return this.targetType === GEnum.TargetType.Class && this.isOneSchoolClassSearch;
  }

  get competencyRanking(): SchoolGroupCompetencyRanking[] {
    return groupModule.competencyRanking;
  }

  get competencySettings(): CompetencySetting[] {
    return groupModule.competencySettings;
  }

  get schoolGroupCompetencyRanking(): SchoolGroupCompetencyRanking[] {
    if (this.competencyRanking && this.competencySettings) {
      return this.competencyRanking.filter((d1: SchoolGroupCompetencyRanking) => this.competencySettings.some((d2: CompetencySetting) => d1.competencyID === d2.competencyID));
    }
  }

  get growingPurposes(): GrowingPurpose[] {
    return masterModule.growingPurposes;
  }

  get tags(): Tag[] {
    return studentFilterModule.tags;
  }

  get selectedCommaTagIDs(): string {
    return studentFilterModule.commaSelectedTagIDs;
  }

  get grade(): number {
    return studentFilterModule.grade;
  }

  get schoolClassID(): number {
    return studentFilterModule.schoolClassID;
  }

  get isGroupSettingsDataSubmitted(): boolean {
    return groupModule.groupModalProperty.isGroupSettingsDataSubmitted;
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  get schoolGroups(): SchoolGroup[] {
    return groupModule.schoolGroups;
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }

  handleSchoolClassTrend(schoolClassID: number) {
    const schoolClassTrend = this.schoolClassTrendBySchoolClassID(schoolClassID);
    schoolClassModule.setSchoolClassTrendResult(schoolClassTrend);
  }

  openConfirm(ok: () => void, cancel: () => void) {
    let config = {
      title: this.$t('CONFIRM_RESET_GROUPING').toString(),
      onOk: () => {
        const schoolGroupSettingInfoOptions = {
          isShowGroupsettingModal: false,
          isGroupSettingsDataSubmitted: false,
        };
        groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
        ok();
      },
      onCancel: () => {
        cancel();
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  //クラスや学年を更新時に、リソースの再取得を行う
  handleSearch(): void {
    if (this.isGroupSettingsDataSubmitted) {
      this.openConfirm(
        //OK押下時は画面遷移を許容する
        () => {
          this.fetchResources();
        },
        () => {}
      );
    } else {
      this.fetchResources();
    }
  }
  fetchResources(): void {
    this.isSearchResultShow = true;
    //一度データをリセット(Loadingを一時的に表示させるため)
    statisticsModule.cleanSchoolGroupPMAnalysis();
    statisticsModule.cleanSchoolGroupTrendAnalysis();

    groupModule.cleanSchoolGroupSetting();
    groupModule.cleanCompetencyRanking();
    groupModule.cleanSchoolGroups();
    schoolClassModule.cleanSchoolClassTrendResult();

    //表示コンテンツを制御
    if (this.isSchoolClassSearch) {
      this.isShowSchoolClassTrend = true;
    } else {
      this.isShowSchoolClassTrend = false;
    }

    //Loadingタイマー再スタート
    const { schoolGroupPmAnalysisComponent, schoolGroupTrendAnalysisComponent, competencyRankingComponent, groupingProposalComponent, schoolClassTrendComponent }: any = this.$refs;
    if (schoolGroupPmAnalysisComponent) {
      schoolGroupPmAnalysisComponent.startTimer();
    }
    if (schoolGroupTrendAnalysisComponent) {
      schoolGroupTrendAnalysisComponent.startTimer();
    }
    if (competencyRankingComponent) {
      competencyRankingComponent.startTimer();
    }
    if (groupingProposalComponent) {
      groupingProposalComponent.startTimer();
    }
    if (schoolClassTrendComponent) {
      schoolClassTrendComponent.startTimer();
    }

    //取得リソースの表示切り替え
    for (const growingPurpose of this.growingPurposes.sort((a: GrowingPurpose, b: GrowingPurpose) => (a.growingPurposeID < b.growingPurposeID ? -1 : 1))) {
      this.handleFetchSchoolGroupPMAnalysis(growingPurpose.growingPurposeID);
    }
    if (this.isSchoolClassSearch) {
      this.handleSchoolClassTrend(this.targetID);
    }

    //傾向チェック分析データ取得
    statisticsModule.fetchSchoolGroupTrendAnalysis({
      targetType: this.targetType,
      targetID: this.targetID,
      selectedCommaTagIDs: this.selectedCommaTagIDs,
    });

    // グルーピングバリデーション用 生徒一覧
    this.fetchStudents();

    //グループ一覧取得
    groupModule.fetchSchoolGroup({
      targetType: this.targetType === 0 ? -1 : this.targetType,
      targetID: this.targetID === 0 ? -1 : this.targetID,
      selectedCommaTagIDs: this.selectedCommaTagIDs,
    } as SchoolGroupSearch);
    //コンピテンシーランキング表示設定取得
    groupModule.fetchCompetencySetting({
      targetType: this.targetType,
      targetID: this.targetID,
    } as SchoolGroupSearch);
    //コンピテンシーランキング取得
    groupModule.fetchCompetencyRanking({
      targetType: this.targetType,
      targetID: this.targetID,
      selectedCommaTagIDs: this.selectedCommaTagIDs,
    } as CompetencyRankingParams);
  }

  fetchStudents() {
    let studentSearchOptions: StudentSearch = {
      targetType: this.targetType,
      targetID: this.targetID,
      keyword: studentFilterModule.searchWord,
      selectedTagIDs: studentFilterModule.commaSelectedTagIDs,
      hasScore: false,
    };
    studentModule.fetchStudents(studentSearchOptions);
  }

  clearStudentFilters(): void {
    studentFilterModule.clear();
  }

  schoolClassTrendBySchoolClassID(schoolClassID: number): SchoolClassTrendResult {
    return schoolClassModule.schoolClassTrendResultBySchoolClassID(schoolClassID);
  }
}
